import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    /*
        COLORS BASE (LIGHT):
            --bg-color: #f9f9f9;

            --color-white: #F1F3F4;
            --color-white-hover: #d8dadb;

            --color-black: #202124;
            --color-black-hover: #141516;

            --color-title:#292A2D;
            --color-text: #35363A;
        
        COLORS BASE (DARK):
            --bg-color: #202124;

            --color-white: #292A2D;
            --color-black: #F1F3F4;

            --color-title:#F1F3F4;
            --color-text: #F9F9F9;
    */
    :root{
        --font-family: 'JetBrains Mono', monospace;

        --font-normal: 400;
        --font-medium: 500;
        --font-bold: 700;

        --button-radius: 0.5rem;

        //COLORS BASE (LIGHT):
        --bg-color: #f9f9f9;

        --color-white: #F1F3F4;
        --color-white-hover: #d8dadb;

        --color-black: #202124;
        --color-black-hover: #141516;

        --color-title:#292A2D;
        --color-text: #35363A;

    }

    #darkmode-toggle,
    :root:has(#darkmode-toggle:checked){
       // COLORS BASE (DARK):
        --bg-color: #202124;

        --color-white: #292A2D;
        --color-white-hover: #141516;
        --color-black: #F1F3F4;
        --color-black-hover: #d8dadb;

        --color-title:#F1F3F4;
        --color-text: #F9F9F9;
    }

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth;

        @media (max-width:1024px){
            font-size: 93,75%; //15px
        }

        @media (max-width:768px){
            font-size: 87,5%; //14px
        }
    }

    body{
        -webkit-font-smoothing: antialiased;
        background-color: var(--bg-color);
    }

    body, 
    input, 
    textarea,
    button{
        font-family: var(--font-family);
    }

    body, 
    input, 
    textarea{
        font-weight: var(--font-normal);
    }

    h1, h2, h3, h4, h5, h6{
        font-weight: var(--font-bold);
    }

    button{
        cursor: pointer;
        font-weight: var(--font-medium);
    }

    [disabled]{
        opacity: 0.6;
        cursor: not-allowed;
    }

    ul{
        list-style: none;
    }

    a{
        text-decoration: none;
    }

    .show-menu{bottom: 0!important}

    .swiper-pagination-bullet{
        width: 10px!important;
        height: 10px!important;
        background-color: var(--color-text)!important;
    }
    .swiper-pagination-bullet-active{
        background-color: var(--color-title)!important;
    }
`